import { DataBean } from "../DataBean";

export class InfoForTaxCertificate extends DataBean {



    public async getInfoForTaxCertificateCatalog(year:any,sheetName:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getInfoForTaxCertificateCatalog_Number_String", [year,sheetName]);
    }
     public async deleteInfoForTaxCertificate(idInfoForTaxCertificate:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteInfoForTaxCertificate_Number", [idInfoForTaxCertificate]);
    }
     public async updateInfoForTaxCertificate(bean:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.admin.InfoForTaxCertificate_updateInfoForTaxCertificate_com.quickdataerp.bean.admin.InfoForTaxCertificate", [
            {
                "DataBeanProperties": bean,
                "DataBeanName": "com.quickdataerp.bean.admin.InfoForTaxCertificate"
            }
        ]);
    }
}